var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.19294 9.71823C5.96948 9.0899 15.3164 6.13677 18.7153 1.23582C14.4667 0.450407 5.96948 1.23608 2.19294 9.71823Z",
    fill: "url(#paint0_linear_3773_6851)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 19.4069C0.587321 16.014 1.24881 12.546 1.72078 11.1322C9.27385 10.661 15.8828 7.83353 20.6034 1.70733C22.4917 2.17857 25.7962 4.5348 27.2124 5.94854C22.4917 9.71851 16.6754 10.9245 12.8988 12.3383C10.048 13.4055 3.86033 17.2078 1.34263 19.4069Z",
    fill: "url(#paint1_linear_3773_6851)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81781 26.4756C3.13698 24.3271 2.51334 22.8628 2.04127 21.2919C4.24424 19.4069 8.17814 16.1082 14.7871 13.752C19.5321 12.0603 23.4358 10.661 28.1565 7.36228C30.6426 9.72243 31.0807 13.6865 30.9889 15.3735C27.9992 16.0018 24.38 15.8447 16.6753 19.4069C12.3595 21.4024 11.1621 21.9709 5.81781 26.4756Z",
    fill: "url(#paint2_linear_3773_6851)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23401 27.8894C9.27385 29.9821 11.7915 30.1392 13.0504 30.4533C16.0716 24.0444 24.0653 23.8559 28.1565 24.3271C30.0448 21.9709 30.3595 18.9863 30.5168 17.2584C17.771 20.0859 11.4826 24.1194 7.23401 27.8894Z",
    fill: "url(#paint3_linear_3773_6851)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9386 30.9246C18.4005 31.2387 24.0967 30.7361 26.7403 26.2121C23.4358 25.7409 17.771 26.2121 14.9386 30.9246Z",
    fill: "url(#paint4_linear_3773_6851)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19294 9.71823C5.96948 9.0899 15.3164 6.13677 18.7153 1.23582C14.4667 0.450407 5.96948 1.23608 2.19294 9.71823Z",
    stroke: "url(#paint5_linear_3773_6851)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 19.4069C0.587321 16.014 1.24881 12.546 1.72078 11.1322C9.27385 10.661 15.8828 7.83353 20.6034 1.70733C22.4917 2.17857 25.7962 4.5348 27.2124 5.94854C22.4917 9.71851 16.6754 10.9245 12.8988 12.3383C10.048 13.4055 3.86033 17.2078 1.34263 19.4069Z",
    stroke: "url(#paint6_linear_3773_6851)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81781 26.4756C3.13698 24.3271 2.51334 22.8628 2.04127 21.2919C4.24424 19.4069 8.17814 16.1082 14.7871 13.752C19.5321 12.0603 23.4358 10.661 28.1565 7.36228C30.6426 9.72243 31.0807 13.6865 30.9889 15.3735C27.9992 16.0018 24.38 15.8447 16.6753 19.4069C12.3595 21.4024 11.1621 21.9709 5.81781 26.4756Z",
    stroke: "url(#paint7_linear_3773_6851)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23401 27.8894C9.27385 29.9821 11.7915 30.1392 13.0504 30.4533C16.0716 24.0444 24.0653 23.8559 28.1565 24.3271C30.0448 21.9709 30.3595 18.9863 30.5168 17.2584C17.771 20.0859 11.4826 24.1194 7.23401 27.8894Z",
    stroke: "url(#paint8_linear_3773_6851)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9386 30.9246C18.4005 31.2387 24.0967 30.7361 26.7403 26.2121C23.4358 25.7409 17.771 26.2121 14.9386 30.9246Z",
    stroke: "url(#paint9_linear_3773_6851)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19295 9.71823C5.96948 9.0899 15.3164 6.13677 18.7153 1.23582C14.4667 0.450407 5.96948 1.23608 2.19295 9.71823Z",
    fill: "#057DBE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 19.4069C0.587326 16.014 1.24882 12.546 1.72078 11.1322C9.27385 10.661 15.8828 7.83353 20.6035 1.70733C22.4917 2.17857 25.7962 4.5348 27.2124 5.94854C22.4917 9.71851 16.6754 10.9245 12.8989 12.3383C10.048 13.4055 3.86033 17.2078 1.34263 19.4069Z",
    fill: "#057DBE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81781 26.4756C3.13698 24.3271 2.51335 22.8628 2.04128 21.2919C4.24425 19.4069 8.17815 16.1082 14.7871 13.752C19.5321 12.0603 23.4359 10.661 28.1565 7.36228C30.6426 9.72243 31.0807 13.6865 30.9889 15.3735C27.9992 16.0018 24.38 15.8447 16.6754 19.4069C12.3595 21.4024 11.1621 21.9709 5.81781 26.4756Z",
    fill: "#057DBE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23401 27.8894C9.27385 29.9821 11.7915 30.1392 13.0504 30.4533C16.0716 24.0444 24.0653 23.8559 28.1565 24.3271C30.0448 21.9709 30.3595 18.9863 30.5169 17.2584C17.7711 20.0859 11.4826 24.1194 7.23401 27.8894Z",
    fill: "#057DBE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19295 9.71823C5.96948 9.0899 15.3164 6.13677 18.7153 1.23582C14.4667 0.450407 5.96948 1.23608 2.19295 9.71823Z",
    stroke: "#057DBE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 19.4069C0.587326 16.014 1.24882 12.546 1.72078 11.1322C9.27385 10.661 15.8828 7.83353 20.6035 1.70733C22.4917 2.17857 25.7962 4.5348 27.2124 5.94854C22.4917 9.71851 16.6754 10.9245 12.8989 12.3383C10.048 13.4055 3.86033 17.2078 1.34263 19.4069Z",
    stroke: "#057DBE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81781 26.4756C3.13698 24.3271 2.51335 22.8628 2.04128 21.2919C4.24425 19.4069 8.17815 16.1082 14.7871 13.752C19.5321 12.0603 23.4359 10.661 28.1565 7.36228C30.6426 9.72243 31.0807 13.6865 30.9889 15.3735C27.9992 16.0018 24.38 15.8447 16.6754 19.4069C12.3595 21.4024 11.1621 21.9709 5.81781 26.4756Z",
    stroke: "#057DBE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23401 27.8894C9.27385 29.9821 11.7915 30.1392 13.0504 30.4533C16.0716 24.0444 24.0653 23.8559 28.1565 24.3271C30.0448 21.9709 30.3595 18.9863 30.5169 17.2584C17.7711 20.0859 11.4826 24.1194 7.23401 27.8894Z",
    stroke: "#057DBE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19295 9.71823C5.96948 9.0899 15.3164 6.13677 18.7153 1.23582C14.4667 0.450407 5.96948 1.23608 2.19295 9.71823Z",
    fill: "#41B9C3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 19.4069C0.587326 16.014 1.24882 12.546 1.72078 11.1322C9.27385 10.661 15.8828 7.83353 20.6035 1.70733C22.4917 2.17857 25.7962 4.5348 27.2124 5.94854C22.4917 9.71851 16.6754 10.9245 12.8989 12.3383C10.048 13.4055 3.86033 17.2078 1.34263 19.4069Z",
    fill: "#41B9C3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81781 26.4756C3.13698 24.3271 2.51335 22.8628 2.04128 21.2919C4.24425 19.4069 8.17815 16.1082 14.7871 13.752C19.5321 12.0603 23.4359 10.661 28.1565 7.36228C30.6426 9.72243 31.0807 13.6865 30.9889 15.3735C27.9992 16.0018 24.38 15.8447 16.6754 19.4069C12.3595 21.4024 11.1621 21.9709 5.81781 26.4756Z",
    fill: "#41B9C3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19295 9.71823C5.96948 9.0899 15.3164 6.13677 18.7153 1.23582C14.4667 0.450407 5.96948 1.23608 2.19295 9.71823Z",
    stroke: "#41B9C3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 19.4069C0.587326 16.014 1.24882 12.546 1.72078 11.1322C9.27385 10.661 15.8828 7.83353 20.6035 1.70733C22.4917 2.17857 25.7962 4.5348 27.2124 5.94854C22.4917 9.71851 16.6754 10.9245 12.8989 12.3383C10.048 13.4055 3.86033 17.2078 1.34263 19.4069Z",
    stroke: "#41B9C3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81781 26.4756C3.13698 24.3271 2.51335 22.8628 2.04128 21.2919C4.24425 19.4069 8.17815 16.1082 14.7871 13.752C19.5321 12.0603 23.4359 10.661 28.1565 7.36228C30.6426 9.72243 31.0807 13.6865 30.9889 15.3735C27.9992 16.0018 24.38 15.8447 16.6754 19.4069C12.3595 21.4024 11.1621 21.9709 5.81781 26.4756Z",
    stroke: "#41B9C3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19295 9.71823C5.96948 9.0899 15.3164 6.13677 18.7153 1.23582C14.4667 0.450407 5.96948 1.23608 2.19295 9.71823Z",
    fill: "#5ABB7F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 19.4069C0.587326 16.014 1.24882 12.546 1.72078 11.1322C9.27385 10.661 15.8828 7.83353 20.6035 1.70733C22.4917 2.17857 25.7962 4.5348 27.2124 5.94854C22.4917 9.71851 16.6754 10.9245 12.8989 12.3383C10.048 13.4055 3.86033 17.2078 1.34263 19.4069Z",
    fill: "#5ABB7F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19295 9.71823C5.96948 9.0899 15.3164 6.13677 18.7153 1.23582C14.4667 0.450407 5.96948 1.23608 2.19295 9.71823Z",
    stroke: "#5ABB7F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 19.4069C0.587326 16.014 1.24882 12.546 1.72078 11.1322C9.27385 10.661 15.8828 7.83353 20.6035 1.70733C22.4917 2.17857 25.7962 4.5348 27.2124 5.94854C22.4917 9.71851 16.6754 10.9245 12.8989 12.3383C10.048 13.4055 3.86033 17.2078 1.34263 19.4069Z",
    stroke: "#5ABB7F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19141 9.71823C5.96794 9.0899 15.3149 6.13677 18.7137 1.23582C14.4651 0.450407 5.96794 1.23608 2.19141 9.71823Z",
    fill: "#8CBE28",
    stroke: "#8CBE28"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3773_6851",
    x1: 16.8269,
    y1: 24.7984,
    x2: 24.3677,
    y2: 31.8802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3773_6851",
    x1: 16.8269,
    y1: 24.7984,
    x2: 24.3677,
    y2: 31.8802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3773_6851",
    x1: 16.8269,
    y1: 24.7984,
    x2: 24.3677,
    y2: 31.8802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3773_6851",
    x1: 16.8269,
    y1: 24.7984,
    x2: 24.3677,
    y2: 31.8802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3773_6851",
    x1: 16.8269,
    y1: 24.7984,
    x2: 24.3677,
    y2: 31.8802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3773_6851",
    x1: 18.7152,
    y1: 25.2696,
    x2: 23.4262,
    y2: 30.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3773_6851",
    x1: 18.7152,
    y1: 25.2696,
    x2: 23.4262,
    y2: 30.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3773_6851",
    x1: 18.7152,
    y1: 25.2696,
    x2: 23.4262,
    y2: 30.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3773_6851",
    x1: 18.7152,
    y1: 25.2696,
    x2: 23.4262,
    y2: 30.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3773_6851",
    x1: 18.7152,
    y1: 25.2696,
    x2: 23.4262,
    y2: 30.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small-logo.862eb250398a6729c3caec5d35fdf4ab.svg";
export { ForwardRef as ReactComponent };